// extracted by mini-css-extract-plugin
export default {"simpleRow":"SimpleFinancialTableRow_simpleRow__k1Ze-","row":"SimpleFinancialTableRow_row__DlC7k"};